
























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/rules-engine';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { getHealthInsurance } from '@/services/prescription';

@Component({
  components: { PermissionAuth },
})
export default class ClientUnitInsurance extends BaseComponent {
  @Prop()
  public value: any[];
  @Prop({
    default: false,
  })
  public isEdit: boolean;

  public healthInsurance: any[] = [];
  public selectedHealthInsurance: any[] = [];

  @Watch('value')
  public onValueChange(val): void {
    this.selectedHealthInsurance = val;
  }

  @Watch('selectedHealthInsurance')
  public onSelectedHealthInsuranceChange(val): void {
    this.$emit('input', val);
  }

  public beforeMount() {
    this.getHealthInsurance();
  }

  private getHealthInsurance(): void {
    getHealthInsurance().subscribe((data) => {
      this.healthInsurance = data;
    });
  }
}
